import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-car",
  templateUrl: "./med-icon-car.component.html",
})
export class MedIconCarComponent extends SvgMixinComponent {}
